import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import { FormButtons, renderers, validations } from '../../components'
import { ResendOTPButton } from './ResendOTPButton'

let OTPSubmitForm = (props) => {
  const [isBackButtonVisible, setBackButtonVisible] = useState(false)
  const { handleSubmit, pristine, reset, submitting, goBack } = props

  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="otp"
        type="password"
        component={renderers.renderField}
        label="OTP"
        validate={[validations.required]}
      />
      <ReactBootstrap.Row>
        <ReactBootstrap.Col className="text-left">
          <ResendOTPButton
            className="p-0 float-left btn text-dark btn-sm"
            onRequestOTP={props.getOTPHandler}
            onButtonStateChanged={setBackButtonVisible}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col className="text-end">
          {isBackButtonVisible && (
            <ReactBootstrap.Button
              onClick={(e) => goBack()}
              variant="link"
              className=" float-end btn text-dark btn-sm"
            >
              Different Source
            </ReactBootstrap.Button>
          )}
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
OTPSubmitForm = reduxForm({
  form: 'OTPSubmitForm',
})(OTPSubmitForm)

export default OTPSubmitForm
